import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 17.5a7.5 7.5 0 0 0 7.5-7.5A7.5 7.5 0 0 0 10 2.5 7.5 7.5 0 0 0 2.5 10a7.5 7.5 0 0 0 7.5 7.5m-1.172-5.156h.703v-1.875h-.703a.7.7 0 0 1-.703-.703c0-.39.313-.703.703-.703h1.406c.39 0 .704.313.704.703v2.578h.234c.39 0 .703.313.703.703s-.313.703-.703.703H8.828a.7.7 0 0 1-.703-.703c0-.39.313-.703.703-.703M10 8.125a.936.936 0 1 1 0-1.875.936.936 0 1 1 0 1.875"
    }, null, -1)
  ]))]))
}
export default { render: render }